/**
 * @Author: Li, Yu Jia
 * @Date: 2020-03-21 15:14:16
 * @Last Modified by: Li, Yu Jia
 * @Last Modified time: 2020-09-25 16:27:19
 */

import Countdown, { zeroPad } from 'react-countdown';

import MessageBox from './../MessageBox';
import PropTypes from 'prop-types';
import React from 'react';
import { getTokenWarningShow } from '../../selectors';
import { messageBoxButtons } from './../../constants';
import { useSelector } from 'react-redux';

const TokenWarning = (props) => {
  const { onCancelClick, onContinueClick } = props;
  const showTokenWarning = useSelector(getTokenWarningShow);
  const cancelHandler = () => {
    onCancelClick();
  };
  const continueHandler = () => {
    onContinueClick();
  };

  const getWarningText = () => {
    return (
      <>
        Your session is about to expire in
        <Countdown
          key="countdown"
          date={Date.now() + 5 * 60 * 1000}
          renderer={({ minutes, seconds }) => ` ${minutes}:${zeroPad(seconds)} `}
        />
        minutes. Please press "Continue" to finish customizing.
      </>
    );
  };

  return (
    <>
      <MessageBox
        closeButton={false}
        show={showTokenWarning}
        buttons={messageBoxButtons.ok}
        buttonsCaption={['Continue']}
        onOk={continueHandler}
        onClose={cancelHandler}
        text={getWarningText()}
      />
    </>
  );
};
TokenWarning.propTypes = {
  onCancelClick: PropTypes.func.isRequired,
  onContinueClick: PropTypes.func.isRequired,
};

export default TokenWarning;
